export default "__VITE_ASSET__BC2oF$ZV__"